// extracted by mini-css-extract-plugin
export default {"root":"ExaminationMethodResultModal_root__itlUC","title":"ExaminationMethodResultModal_title__aLafQ","pointsTitle":"ExaminationMethodResultModal_pointsTitle__PCJPx"};